import React from 'react';
import Input from 'es6/components/registration/inputs/input';

function ReferralInput(props) {
  return (<Input type="hidden" name="referral_token" {...props} />);
}

export default ReferralInput;
